export const ligainicial = "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/proc/";

export const pagesipdus = "https://s-infraestructura.hidalgo.gob.mx/digital_files/procedures/";